import {SecureService} from "@/services/superclasses/secure-service";
import {Subscription} from "@/interfaces/subscription";

const api = window.contextPath + '/rest/subscriptions';

export class SubscriptionSecureService extends SecureService {

    public loadByPerson = async (): Promise<Subscription> => {
        return this.data(await this.get<Subscription>(api + "/by-person"))
    };
}

export const subscriptionSecureService = new SubscriptionSecureService()